import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import { action } from "@ember/object"
import styles from "./outline-button.module.css"

@tagName("")
export default class OutlineButtonComponent extends Component {
  readonly styles = styles

  //args
  onClick!: Function | null

  @action
  clickButton() {
    if (this.onClick) this.onClick()
  }
}
